import React from 'react'

import { BaseView, BaseText } from '@/components/base'

interface InfoItemProps {
  title: string
  value?: string
  valueIsLink?: boolean
  valueComponent?: () => React.ReactNode
  onClickLink?: () => void
}

export const InfoItem: React.FC<InfoItemProps> = ({
  title,
  value,
  valueIsLink,
  valueComponent,
  onClickLink,
}) => {
  return (
    <BaseView row align="center" justify="space-between" py={5}>
      <BaseText fontSize={16} fontFamily="semibold" color="label.default">
        {title}
      </BaseText>

      {valueComponent && valueComponent()}

      {!valueComponent && (
        <BaseText
          fontSize={16}
          fontFamily="bold"
          color={valueIsLink ? 'label.link' : 'label.default'}
          style={{
            textDecoration: valueIsLink ? 'underline' : 'none',
            cursor: valueIsLink ? 'pointer' : 'default',
          }}
          onClick={valueIsLink ? onClickLink : undefined}
        >
          {value}
        </BaseText>
      )}
    </BaseView>
  )
}
